<section class="bg-image">
  <div class="mask contant-height d-flex align-items-center gradient-custom-3">
    <div class="container d-grid align-items-center">
      <div class="d-flex justify-content-center">
        <div class="col-12 col-md-9 col-lg-7 col-xl-6 mt-4">
          <div class="text-center mb-4">
            <img
              src="/assets/logo/chessx-light-main-logo.svg"
              class="main-logo"
              alt="logo"
            />
          </div>

          <!-- <div class="card">
                        <div class="card-body p-0"> -->
          <div class="form-main-box justify-content-center">
            <div class="form-box p-2">
              <div class="justify-content-center">
                <div *ngIf="isSignup">
                  <i
                    class="fa-sharp fa-solid fa-circle-arrow-left back-arrow ms-3 mt-3"
                    style="color: #000000; cursor: pointer"
                    (click)="clickSignupPage()"
                  ></i>
                </div>
                <div
                  class="header-signup justify-content-center d-flex mb-3 m-0 mt-3"
                >
                  <!-- <h1><img src="assets/icon-image/card-look-sign-up-image.svg" alt=""></h1> -->
                  <h2 class="Sign-up-title m-0">Sign-up</h2>
                </div>
              </div>

              <div *ngIf="!isSignup">
                <div class="text-center">
                  <img
                    alt="Chess.com"
                    width="75%"
                    src="../../../../../assets/main-image/card-chess-main-image.png"
                  />
                </div>
              </div>

              <!-- <div *ngIf="isSignup" class="mb-4"></div> -->

              <form
                *ngIf="isSignup"
                [formGroup]="signupForm"
                (ngSubmit)="signup(signupForm.value)"
              >
                <div class="inputWithIcon mb-2 d-flex justify-content-center">
                  <input
                    class="border-input"
                    maxlength="10"
                    type="text"
                    placeholder="username"
                    formControlName="username"
                  />
                  <i
                    class="fa fa-address-card fa-lg fa-fw mt-2 ms-2"
                    aria-hidden="true"
                  ></i>
                </div>
                <div
                  class="form-error mb-2"
                  *ngIf="
                    signupForm.controls['username']?.invalid &&
                    (signupForm.controls['username'].dirty ||
                      signupForm.controls['username'].touched ||
                      submitted)
                  "
                >
                  <span
                    class="ms-5 mb-5"
                    style="color: red"
                    *ngIf="signupForm.controls['username'].errors?.['required']"
                    >username is required.</span
                  >
                </div>
                <div class="inputWithIcon mb-2 d-flex justify-content-center">
                  <input
                    class="border-input"
                    type="text"
                    placeholder="Enter your first name"
                    formControlName="firstname"
                  />
                  <i
                    class="fa fa-address-card fa-lg fa-fw mt-2 ms-2"
                    aria-hidden="true"
                  ></i>
                </div>
                <div
                  class="form-error mb-2"
                  *ngIf="
                    signupForm.controls['firstname']?.invalid &&
                    (signupForm.controls['firstname'].dirty ||
                      signupForm.controls['firstname'].touched ||
                      submitted)
                  "
                >
                  <span
                    class="ms-5 mb-5"
                    style="color: red"
                    *ngIf="signupForm.controls['firstname'].errors?.['required']"
                    >First Name is required.</span
                  >
                </div>

                <div class="inputWithIcon mb-2 d-flex justify-content-center">
                  <input
                    class="border-input-1"
                    type="text"
                    placeholder="Enter your last name"
                    formControlName="lastname"
                  />
                  <i
                    class="fa fa-address-card fa-lg fa-fw mt-2 ms-2"
                    aria-hidden="true"
                  ></i>
                </div>

                <div
                  class="form-error"
                  *ngIf="
                    signupForm.controls['lastname']?.invalid &&
                    (signupForm.controls['lastname'].dirty ||
                      signupForm.controls['lastname'].touched ||
                      submitted)
                  "
                >
                  <span
                    class="ms-5"
                    style="color: red"
                    *ngIf="signupForm.controls['lastname'].errors?.['required']"
                    >Last Name is required.</span
                  >
                </div>

                <div class="inputWithIcon mb-2 d-flex justify-content-center">
                  <input
                    class="border-input"
                    type="email"
                    placeholder="Email"
                    formControlName="email"
                  />
                  <i
                    class="fa fa-envelope fa-lg fa-fw mt-2 ms-2"
                    aria-hidden="true"
                  ></i>
                </div>

                <div
                  *ngIf="
                    signupForm.controls['email']?.invalid &&
                    (signupForm.controls['email'].dirty ||
                      signupForm.controls['email'].touched ||
                      submitted)
                  "
                >
                  <span
                    class="form-error ms-5"
                    style="color: red"
                    *ngIf="signupForm.controls['email'].errors?.['required']"
                    >Email is required.</span
                  >
                  <span
                    class="form-error ms-5"
                    *ngIf="signupForm.controls['email'].errors?.['email']"
                    >Enter correct email address.</span
                  >
                  <span
                    *ngIf="signupForm.controls['email'].errors?.['pattern']"
                    class="text-danger ms-5"
                    >Please provide a valid email address</span
                  >
                </div>

                <div class="mb-1 Password-input">
                  <div
                    class="inputWithIcon mb-2 d-flex justify-content-center right-inner-addon input-container"
                  >
                    <i
                      class="lock-icon fa fa-lock fa-lg fa-fw mt-2 ms-2"
                      aria-hidden="true"
                    ></i>

                    <i
                      class="eye-icon fa-solid fa-eye toggle-password"
                      (click)="showPassword = !showPassword"
                      [ngClass]="{
                        'fa-eye': !showPassword,
                        'fa-eye-slash': showPassword
                      }"
                    ></i>
                    <input
                      id="password"
                      placeholder="password"
                      [type]="showPassword ? 'text' : 'password'"
                      class="form-control input-mb border-input"
                      formControlName="password"
                      placeholder="Password"
                    />
                  </div>

                  <div
                    style="color: red"
                    *ngIf="
                      signupForm.controls['password']?.invalid &&
                      (signupForm.controls['password'].dirty ||
                        signupForm.controls['password'].touched ||
                        submitted)
                    "
                    class=""
                  >
                    <span
                      class="form-error ms-5"
                      *ngIf="signupForm.controls['password'].errors?.['required']"
                      >Password is required.</span
                    >
                    <span
                      class="form-error ms-5"
                      *ngIf="signupForm.controls['password'].errors?.['pattern']"
                      >Enter correct Password.</span
                    >
                  </div>
                </div>
                <!-- 
                                <div class="inputWithIcon mb-1 d-flex justify-content-center">
                                    <input *ngIf="!showPassword" type="password" formControlName="password"
                                        class="form-control input-mb border-input-1" id="exampleInputPassword1"
                                        placeholder="Password">
                                    <input *ngIf="showPassword" type="text" class="form-control input-mb"
                                        formControlName="password" id="exampleInputPassword1" placeholder="Password">
                                    <i class="fa fa-lock fa-lg fa-fw mt-2 ms-2" aria-hidden="true"></i>
                                </div>
                                <i class="fa-solid fa-eye float-right icon-eyes" (click)="showPassword = !showPassword"
                                    [ngClass]="{
                                      'fa fa-fa-solid fa-eye fa-lg fa-fw': !showPassword,
                                      'fa fa-eye-slash fa-lg fa-fw': showPassword
                                    }"></i> -->

                <div
                  class="d-flex align-items-center justify-content-evenly select-mode pb-2"
                >
                  <label class="me-2">
                    <input
                      type="radio"
                      [value]="1"
                      name="level"
                      formControlName="level"
                    />
                    <img
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Beginner"
                      src="assets/icon-image/chess.svg"
                      style="width: 50px; height: 50px"
                      alt=""
                    />
                  </label>

                  <label class="">
                    <input
                      type="radio"
                      [value]="2"
                      name="level"
                      formControlName="level"
                    />
                    <img
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Intermediate"
                      src="assets/icon-image/knight.svg"
                      style="width: 50px; height: 50px"
                      alt=""
                    />
                  </label>

                  <label class="">
                    <input
                      type="radio"
                      [value]="3"
                      name="level"
                      formControlName="level"
                    />
                    <img
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Advanced"
                      src="assets/icon-image/king.svg"
                      style="width: 50px; height: 50px"
                      alt=""
                    />
                  </label>
                </div>

                <div class="text-center" *ngIf="isSignup">
                  <button
                    type="submit"
                    class="btn btn-primary btn-lg sinup-btn mb-2"
                  >
                    Sign-Up
                  </button>
                </div>
              </form>

              <div class="text-center" *ngIf="!isSignup">
                <button
                  type="button"
                  class="btn btn-lg sinup-btn"
                  (click)="clickSignupPage()"
                >
                  Sign-up
                </button>
              </div>

              <div class="text-center mt-3" *ngIf="!isSignup">
                <button
                  type="button"
                  class="btn btn-lg LogIn-btn"
                  (click)="onClick()"
                >
                  Log In
                </button>
              </div>

              <!-- <div class="d-grid gap-2 col-8 mx-auto text-center">
                                <button class="btn sinup-btn" type="button">Sign-up</button>
                            </div>
                            <div class="d-grid gap-2 col-8 mx-auto text-center mt-2">
                                <button class="btn LogIn-btn" type="button">Log In</button>
                            </div> -->

              <div class="main-or-div my-3" *ngIf="!isSignup">
                <span></span>
                <span class="main-or-text mb-2">or</span>
                <span></span>
              </div>

              <div
                class="text-center mb-3 justify-content-between"
                *ngIf="!isSignup"
              >
                <button
                  type="button"
                  class="btn btn-lg google-btn btn-clr"
                  (click)="signInWithGoogle()"
                >
                  <img
                    height="30"
                    src="../../../../../assets/icon-image/googleImage.svg"
                    width="45"
                    class="mt-1 google-img"
                  />
                  <span class="continue-text">Continue with Google</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div>
    </div> -->
</section>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: displayStyle2 }"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <h4 class="modal-title text-center m-0">Enter Your OTP</h4>

        <div class="text-center">
          <img
            style="width: 50%"
            src="/assets/main-image/forgot-password-img.svg"
            alt=""
          />
        </div>

        <form [formGroup]="confirmOtp" (ngSubmit)="OtpPopups()" action="">
          <div>
            <div class="password-input otp-popup mb-2">
              <div class="inputWithIcon mb-1">
                <input
                  style="width: 100%"
                  type="text"
                  name="otp"
                  id="otp"
                  formControlName="otp"
                  placeholder="Enter your OTP"
                  class="input-mb"
                />
                <i class="fa fa-envelope fa-lg fa-fw" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </form>
        <div class="modal-footer d-flex justify-content-between">
          <button
            type="button"
            (click)="otpClosePopUp()"
            class="btn profile-edit-button fw-bold text-uppercase btn-light shadow rounded password-input-reset"
          >
            Cancel
          </button>
          <button
            type="button"
            (click)="OtpPopups()"
            [disabled]="confirmOtp.invalid"
            class="btn profile-edit-button fw-bold text-uppercase btn-light shadow rounded password-input-save"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
